import { z } from "zod";
import { Unit } from "../shared/unit.js";

export const Holding = z.object({
  organisation_id: z.string(),
  location_id: z.string(),
  product_id: z.string(),
  batch_number: z.optional(z.string()),
  best_before: z.optional(z.string()),
  rotation_number: z.optional(z.string()),
  rotation_line: z.optional(z.number()),
  unit: Unit,
  quantity: z.string(),
});
